<template lang="pug">
  v-content
    v-container.grey.lighten-4
      v-row
        v-col
          pageTitle お得意先詳細表示
    v-container.indigo.lighten-5
      v-card
        v-card-text
          v-row
            v-col(cols=10)
              .text--primary
                | ( {{ customer.kana}} )
                br
                | {{ customer.name }}
            v-col(cols=2)
              ToolTipIcon(v-if="!isHide" @click="hide_item(true)" icon="mdi-eye"
                large color="blue darken-2"
              ) 無効にする
              ToolTipIcon(v-if="isHide" @click="hide_item(false)" icon="mdi-eye-off" large) 有効にする
            v-col
              v-card(outlined)
                v-card-subtitle
                  span.font-italic 伝票上の表示:
                v-card-text
                  pre.text--primary
                    | {{ customer.label }} {{ customer.keisyo }}
          v-row
            v-col(cols=1)
            v-col(cols=3) 締め日:&nbsp;
              span.text--primary {{ customer.shimebi }}日
            v-col 入金先口座：&nbsp;
              span.text--primary {{ ba2str(bank_account) }}
          v-row
            v-col(cols=2)
              .text--primary 〒 {{ customer.zip }}
            v-col
              .text--primary
                | {{ customer.address }}
                br
                | tel. {{ customer.phone }}
                | fax. {{ customer.fax }}
          v-row
            v-col
              v-card(outlined)
                v-card-subtitle.font-italic 備考:
                v-card-text
                  pre.text--primary {{ customer.note }}
        v-card-actions
          v-spacer
          v-btn(color="primary" width="100"
            @click="$router.push('/customers/edit/' + customer.id)"
          ) 編集
          v-spacer
          v-btn(@click="$router.push('/customers/list')") 一覧に戻る
          v-spacer
</template>

<script>
  // import debugLog from '@/utils/debugLog'
  import { getCustomer, patchCustomer } from '@/api/customer'
  import { getBankAccount } from '@/api/bank_account'
  import pageTitle from '@/components/pageTitle'
  import ToolTipIcon from '@/components/ToolTipIcon'
  import { bank_account2str } from '@/utils/helpers'

  export default {
    name: 'CustomerShow',
    components: {pageTitle, ToolTipIcon},
    data() { return {
      customer: {},
      bank_account: {}
    }},
    computed: {
      isHide() {
        return this.customer.hide
      }
    },
    created() {
      const self = this
      getCustomer(self.$route.params.id).then((res) => {
        self.customer = res.data
        if (res.data.bank_account_id) {
          getBankAccount(res.data.bank_account_id).then((res) => {
            self.bank_account = Object.assign({}, res.data)
          })
        }
      })
    },
    methods: {
      ba2str(ba) {
        return bank_account2str(ba)
      },
      hide_item(hide) {
        patchCustomer({id: this.customer.id, hide: hide}).then(() => {
          this.customer.hide = hide
        })
      }
    }
  }
</script>
